import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
// import parse from "html-react-parser";
// import ReactMarkdown from "react-markdown";

import useApi from "../utils/custom-hooks/useApi";
import { getUser } from "../utils/utility";
import Loading from "../components/Loading";
import { useAppContext } from "../contexts/appContext";

import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css"; // snow theme
import "react-quill/dist/quill.bubble.css"; // bubble theme

const itam =
  "&lt;p>Located on the eastern bank of the Hooghly River, Kolkata is the capital of West Bengal, India, and stands as one of the country's largest and most significant metropolitan cities. It is known for its rich culture, grand colonial architecture, and vibrant heritage. It is the home of some of the greatest thinkers, artists, filmmakers, and writers like Rabindranath Tagore, and Satyajit Ray. Kolkata is known for its grand celebrations of the Hindu festival of Durga Puja, which is recognized by UNESCO for its importance to world heritage. Kolkata is also known as the 'City of Joy`.&lt;/p>&lt;p>&lt;br>&lt;/p>&lt;h2>1 Victoria Memorial&lt;/h2>&lt;p>Victoria Memorial is a grand and historic museum dedicated to Queen Victoria. It is an impressive white marble building &amp; was built between 1906-1921. It's a blend of British and Mughal architecture, with a large central dome and four smaller domes at each corner. It has a vast collection of paintings, sculptures, manuscripts, and other artifacts that showcase India's colonial history and art. There is also a gallery dedicated to Queen Victoria. It has a lush green garden outside of the building. It's a must-visit destination for travelers interested in architecture, history, and art.&lt;/p>&lt;p>&lt;br>&lt;/p>&lt;h3>Travel Tips&lt;/h3>&lt;ul>&lt;li>The entry hours are from 5:30 AM to 6:30 PM.&lt;/li>&lt;li>There is an entry fee of INR 20 for Indians and INR 200 for foreigners. Students with valid IDs or uniforms can tour for free.&lt;/li>&lt;/ul>&lt;h3>&lt;br>&lt;/h3>&lt;h3>Not to Miss&lt;/h3>&lt;ul>&lt;li>In the evening, there is a light and sound show that narrates the history of Kolkata and the memorial.&lt;/li>&lt;/ul>&lt;p>&lt;br>&lt;/p>&lt;p>&lt;>&lt;/p>&lt;p>&lt;br>&lt;/p>&lt;p>&lt;br>&lt;/p>&lt;h2>2. Howrah Bridge&lt;/h2>&lt;p>&lt;br>&lt;/p>&lt;p>Howrah Bridge is an iconic and historic bridge that connects two sides of the city across the Hooghly River. It was built during British colonial rule and was opened to the public in 1943. The bridge is constructed from steel and is supported only at two ends on each side of the river, without any pillars in the water. This design makes the bridge look like it's floating on the river, and that's what makes it unique. The Bridge is not just for transportation but also a cultural and historical icon of Kolkata, often depicted in movies, literature, and art. The bridge provides a fantastic view of the river and the city's skyline. While standing on the bridge, observe the iconic yellow taxis and colorful buses of Kolkata passing by.&lt;/p>&lt;p>&lt;br>&lt;/p>&lt;h3>Not to Miss&lt;/h3>&lt;p>&lt;br>&lt;/p>&lt;ul>&lt;li>Standing in the middle of the bridge on the pedestrian path, you can feel the bridge shaking or swaying when heavy vehicles cross, and you can also enjoy the refreshing cool breeze.&lt;/li>&lt;li>Take a ferry ride from the launch ghat to enjoy a spectacular view of the bridge from below. Try to take a ride at night when the bridge is beautifully lit up with lights.&lt;/li>&lt;/ul>&lt;p>&lt;br>&lt;/p>&lt;p>&lt;>&lt;/p>&lt;p>&lt;br>&lt;/p>&lt;p>&lt;br>&lt;/p>&lt;p>That's it. We will continue to add more places... :)&lt;/p>";
const itam2 =
  "<p>this is the article</p><p><br></p><h2>main head…></ul><h4>second hading</h4><p>pretty amazing</p>";
function SingleArticlePage() {
  const { articleId } = useParams();
  const [title, setTitle] = useState("");
  const [value, setValue] = useState(
    "<h4>This is the default data</h4> <li>Item 1</li><li>Item 2</li>"
  );

  const { addInCache, getFromCache } = useAppContext();
  const { isLoading, error, result, resultRef, makeApiCall } = useApi();

  useEffect(() => {
    const data = getFromCache(`article-id-${articleId}`);
    if (!data) {
      fetchArticle();
    } else {
      setAllData(data);
    }
  }, []);

  const fetchArticle = async () => {
    await makeApiCall("GET", `/article/${articleId}`);
    if (resultRef.current) {
      if (resultRef.current.status) {
        setAllData(resultRef.current);
        addInCache(`article-id-${articleId}`, resultRef.current);
        //
        // setTitle(resultRef.current.article.title);
        // setValue(resultRef.current.article.body);
      } else {
        alert(`FAIL: ${resultRef.current.message}`);
      }
    }
  };

  const setAllData = (response) => {
    setTitle(response.article.title);
    setValue(response.article.body);
  };

  const errorMessage = () => {
    if (error.show) {
      return <h4 className="uk-text-danger">{error.msg}</h4>;
    }
  };

  const showLoading = () => {
    if (isLoading) {
      return <Loading />;
    }
  };

  const modules = {
    toolbar: {},
    clipboard: {
      matchVisual: false,
    },
  };

  const showContent = () => {
    // with the help of chatgpt
    //REASON: It looks like the data you're retrieving from the database is HTML-encoded, with special characters such
    //as < and > replaced by their HTML entities (&lt; and &gt;). To display this HTML-encoded content correctly in your
    //React application, you'll need to decode it before rendering.
    // console.log("ENCODED_HTML: ", value);

    const doc = new DOMParser().parseFromString(value, "text/html");
    const decodedHtml = doc.documentElement.textContent.trim();

    // console.log("DECODED_HTML: ", decodedHtml);
    return (
      <>
        <h2 className="uk-margin-medium-top">{title}</h2>
        {/* approach 1 - space problem is due to css or `TAG` used for creating an empty line while writing article*/}
        <ReactQuill
          value={decodedHtml}
          readOnly={true}
          theme="bubble"
          modules={modules}
        />
        {/* approach 2 // */}
        {/* <div dangerouslySetInnerHTML={{ __html: decodedHtml }} /> */}
        {/* <p
          dangerouslySetInnerHTML={{
            __html: decodedHtml,
          }}
        ></p> */}
      </>
    );
  };

  return (
    <Wrapper className="uk-container uk-container-small uk-margin-medium">
      {showLoading()}
      {errorMessage()}
      {/* How do I display the content of React Quill without the html markup? */}
      {/* https://stackoverflow.com/questions/40952434/how-do-i-display-the-content-of-react-quill-without-the-html-markup */}
      {/* <ReactQuill value={value} readOnly={true} theme="bubble" /> */}
      {!isLoading && showContent()}

      {/* {parse(itam2)} */}
      {/* <div className="ql-editor" style={{ padding: 0 }}>
        <ReactMarkdown escapeHtml={false} source={value} />
      </div> */}
    </Wrapper>
  );
}

const Wrapper = styled.main`
  .ql-editor {
    padding: 0;
  }
`;

export default SingleArticlePage;
